import React from "react";
import "./getInTouch.css";
import NavBar from "../../Layout/NavBar/NavBar";
import { useEffect } from "react";
import work from "../../Assets/work2.jpg";
import { ImLocation } from "react-icons/im";
import { HiOutlineMail } from "react-icons/hi";
import { AiOutlinePhone } from "react-icons/ai";
const GetInTouch = (props) => {
  const openMenu = props.openMenu;
  const onOpen = props.onOpen;
  const t = props.language;
  return (
    <div className="get-in-touch">
      <NavBar
        language={props.language}
        languages={props.languages}
        openMenu={openMenu}
        onOpen={onOpen}
        black={true}
      />
      {!openMenu ? (
        <>
          <div className="filler"></div>
          <div
            className="text__team "
            style={{ color: "black", marginTop: "2rem" }}
          >
            {t("careers")}
            <span className="line__team"></span>
          </div>
          <div className="team__desc--wrap">
            <p className="team__desc" style={{ marginTop: "1rem" }}>
              {t("carrers_text")}
            </p>
          </div>
          {/* <h1 className="careers">{t("careers")}</h1> */}

          <div className="two-parts">
            <div className="left-part">
              <img src={work} className="img-left"></img>
            </div>
            <div className="right-part">
              <div>
                <p className="team_join"> {t("contact_page")}</p>
                <a
                  className="mail-wrap"
                  href="mailto: bsrec-contact@bsrecapital.com"
                >
                  {t("cv")}
                </a>
              </div>
            </div>
          </div>
          <div className="in-touch">
            <div className="info-contact">
              <div className="contact-item">
                <ImLocation className="contact-info-logo" />
                <span className="title_c">{t("find_us")}</span>
                <span className="contact-dsc">
                  65, rue la Boétie, 75008 Paris
                </span>
              </div>
              <div className="contact-item">
                <HiOutlineMail className="contact-info-logo" />
                <span className="title_c">{t("contact_us")}</span>
                <span className="contact-dsc">+33 (0)1 86 22 80 00</span>
              </div>
              <div className="contact-item">
                <AiOutlinePhone className="contact-info-logo" />
                <span className="title_c">{t("write")}</span>
                <span className="contact-dsc">
                  bsrec-contact@bsrecapital.com
                </span>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default GetInTouch;
